import { Router } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { BaseService } from './../shared/service/base.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { User } from '../shared/modal/user-management/user';
import { Constant } from '../shared/constant/constant';
import { MatDialog } from '@angular/material/dialog';
import { MotionComponent } from '../shared/motion/motion.component';
import { environment } from '../../environments/environment';
import { ThemeService } from '../pages/theme/services/theme.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  logInEndPoint = 'api/v1/auth/portal/login';
  registerCustomerEndPoint = 'api/v1/auth/portal/register/customer';
  forgetEndPoint = 'api/v1/auth/send-reset-link';
  checkResetEndPoint = 'api/v1/auth/check-reset-link';
  changePasswordEndPoint = 'api/v1/auth/change-password';
  portalConfigEndPoint = 'api/v1/portal-config/get-config';
  refreshTokenEndPoint = 'api/v1/auth/refresh-access-token';
  logoutEndPoint = 'api/v1/auth/logout';
  REGISTEREndPoint = 'api/v1/auth/register/portal';
  bankList = 'api/v1/bank';
  countryEndPoint = 'api/v1/bank';
  checkPhoneNumber = 'api/v1/auth/check-phone-number?phoneNumber';
  referralSettingEndPoint = 'api/v1/customer-branch/referral-setting';
  CustomerBranchesEndPoint = 'api/v1/customer-branch/customer';
  customerThemeEndPoint = 'api/v1/customer-theme';
  public user: Observable<User>;
  userScreens: any[] = [];
  config = new BehaviorSubject(null); public deviceId;
  constant = new Constant();

  constructor(
    private _base: BaseService,
    private _router: Router,
    private dialog: MatDialog,
    private themeService: ThemeService
  ) {
    this.user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    this.loadCachedConfig();
  }

  private packages: string[] = [];
  private userTypes: string[] = [];

  private getFavoriteStorageSnapshot(): { [key: string]: string } {
    return Object.keys(localStorage)
      .filter((key) => key.startsWith('FAVORITE_PAGES_'))
      .reduce((snapshot, key) => {
        snapshot[key] = localStorage.getItem(key);
        return snapshot;
      }, {} as { [key: string]: string });
  }

  private restoreFavoriteStorage(snapshot: { [key: string]: string }): void {
    Object.keys(snapshot).forEach((key) => {
      if (snapshot[key] != null) {
        localStorage.setItem(key, snapshot[key]);
      }
    });
  }


  // إعداد الباكدج (الصلاحيات)
  setPackages(packages: string[]): void {
    this.packages = packages.map(p => p.toLowerCase());
    localStorage.setItem('packages', JSON.stringify(this.packages));
  }

  // تحميل الباكدج (الصلاحيات)
  loadPackages(): void {
    const data = localStorage.getItem('packages');
    this.packages = data ? JSON.parse(data) : [];
  }

  // الحصول على الباكدج (الصلاحيات)
  getPackages(): string[] {
    return this.packages;
  }

  // التحقق إذا كان لدى المستخدم صلاحية الوصول إلى موديل معين
  hasAccess(code: string): boolean {
    return this.packages.includes(code.toLowerCase());
  }

  // إعداد أنواع المستخدم (عميل، موظف، مدير...)
  setUserTypes(types: any[]): void {
    this.userTypes = types.map(t => t.code);
    localStorage.setItem('userTypes', JSON.stringify(this.userTypes));
  }

  // تحميل أنواع المستخدم
  loadUserTypes(): void {
    const data = localStorage.getItem('userTypes');
    this.userTypes = data ? JSON.parse(data) : [];
  }

  isCustomer(): boolean {
    const user = JSON.parse(localStorage.getItem('CURRENT_USER') || '{}');

    const userTypes = user?.userTypes || [];

    return userTypes.some(
      (type: any) => type.code === 'CUST'
    );
  }


  // التحقق إذا كان المستخدم "ليس عميل" (مثال: موظف أو مدير)
  isNotCustomer(): boolean {
    return !this.isCustomer(); // إذا لم يكن العميل فهو موظف أو مدير
  }



  // private packages: string[] = [];
  // setPackages(packages: string[]) {
  //   this.packages = packages.map(p => p.toLowerCase());
  //   localStorage.setItem('packages', JSON.stringify(this.packages));
  // }


  // loadPackages() {
  //   const data = localStorage.getItem('packages');
  //   this.packages = data ? JSON.parse(data) : [];
  // }



  // getPackages() {
  //   return this.packages;
  // }

  // hasAccess(code: string): boolean {
  //   return this.packages.includes(code.toLowerCase());
  // }


  login(requestBody) {
    const loginReq = {
      login: requestBody.userId,
      password: requestBody.password,
    };

    return this._base.post(loginReq, `${this.logInEndPoint}`).pipe(
      tap(
        (res) => {
          if (res?.data?.accessToken?.length) {
            localStorage.setItem('CURRENT_USER', JSON.stringify(res.data));
            localStorage.setItem('BRANCH_CONFIG', JSON.stringify(res.data.branchConfig));
            localStorage.setItem(
              'ACCESS_TOKEN',
              JSON.stringify(res.data.accessToken)
            );
            localStorage.setItem(
              'REFRESH_TOKEN',
              JSON.stringify(res.data.refreshToken)
            );
            this.getCustomerBranches().subscribe((res) => {
              localStorage.setItem('CUSTOMER_BRANCHES', JSON.stringify(res.data));

            });
            // this.getUserTheme(res.data.branchConfig.customerId).subscribe(
            //   {
            //     next: (res) => {
            //       if (res.success) {
            //         localStorage.setItem('theme', JSON.stringify(res.data));
            //         const customLogoPath = localStorage.getItem('CUSTOM_LOGO_PATH');/// hash
            //         const logoImagePath = localStorage.getItem('LOGO_IMAGE_PATH'); /// hash
            //         const storedThemeData = JSON.parse(localStorage.getItem('THEME_LOGO_DATA') || 'null');
            //         if (storedThemeData) {
            //           res.data.logoPath = storedThemeData.logoUrl;
            //           res.data.imagePathOnly = storedThemeData.imagePath;
            //           res.data.lastUpdated = storedThemeData.timestamp;

            //           localStorage.setItem('LOGO_IMAGE_PATH', storedThemeData.logoUrl); /// hash
            //           localStorage.setItem('CUSTOM_LOGO_PATH', storedThemeData.imagePath);/// hash
            //         } else if (res.data.logoPath) {
            //           // Use theme logo if available
            //           const themeData = {
            //             logoUrl: res.data.logoPath,
            //             imagePath: res.data.imagePathOnly,
            //             timestamp: new Date().getTime()
            //           };
            //           localStorage.setItem('THEME_LOGO_DATA', JSON.stringify(themeData));
            //           localStorage.setItem('LOGO_IMAGE_PATH', res.data.logoPath);/// hash
            //           localStorage.setItem('CUSTOM_LOGO_PATH', res.data.imagePathOnly);/// hash
            //         } else {
            //           localStorage.setItem('LOGO_IMAGE_PATH', './assets/images/newLogo.png');/// hash
            //           localStorage.removeItem('CUSTOM_LOGO_PATH');/// hash
            //           localStorage.removeItem('THEME_LOGO_DATA');
            //         }
            //         document.documentElement.style.setProperty('--mat-theme-primary-color', res.data.primary.background ?? '#6a1b9a');
            //         document.documentElement.style.setProperty('--mat-theme-accent-color', res.data.accent.background ?? '#e44891');
            //       } else {
            //         this.setDefaultTheme();
            //       }
            //     },
            //     error: (error) => this.setDefaultTheme()
            //   }
            // );
            this.getUserTheme(res.data.branchConfig?.customerId).subscribe({
              next: (res) => {
                if (res.success && res.data) {
                  // Always clear previous customer's branding first
                  localStorage.removeItem('LOGO_IMAGE_PATH');
                  localStorage.removeItem('CUSTOM_LOGO_PATH');
                  localStorage.removeItem('THEME_LOGO_DATA');
                  localStorage.removeItem('THEME_FONT');

                  // Store font if available
                  if (res.data.fontFamily) {
                    localStorage.setItem('THEME_FONT', res.data.fontFamily);
                    document.documentElement.style.setProperty('--theme-font-family', res.data.fontFamily);
                  } else {
                    document.documentElement.style.setProperty('--theme-font-family', 'Cairo');
                  }

                  // Apply theme using ThemeService
                  this.themeService.applyCustomerTheme(res.data);

                  // Now fetch logo image after theme is stored
                  this.updateLogoImage();
                } else {
                  // No theme data - reset to defaults
                  this.clearBrandingCache();
                  this.setDefaultTheme();
                }
              },
              error: (error) => {
                console.log(error)
                this.clearBrandingCache();
                this.setDefaultTheme()
              }
            });


            this.userScreens = [];
            res.data.userPrivilage.menu.forEach((element) => {
              element.screens.forEach((screen) => {
                // Validate screen data before adding
                if (screen && screen.routingPath) {
                  this.userScreens.push(screen);
                }
              });
            });
            localStorage.setItem(
              'USER_SCREENS',
              JSON.stringify(this.userScreens)
            );
            this.requestConfigData();
            // this._base.isNotPos.next(true);
            localStorage.setItem('IS_NOT_POS', JSON.stringify(true));
          }
        },
        (error) => {
          this.checkAccountValidity(error);
        },
        () => {
          console.log('Login process completed');
        }
      )
    );
  }
  setDefaultTheme() {
    const defaultTheme = {
      accent: { background: '#f72585', foreground: '#fff' },
      icon: '#29343d',
      iconPath: null,
      id: null,
      primary: { background: '#7209b7', foreground: '#fff' },
      statusCode: 1,
      text: { primary: '#29343d', secondary: '#526b7a' }
    };
    // Apply theme using ThemeService instead of just storing in localStorage
    this.themeService.applyCustomerTheme(defaultTheme);
    document.documentElement.style.setProperty('--mat-theme-primary-color', '#6a1b9a');
    document.documentElement.style.setProperty('--mat-theme-accent-color', '#e44891');
    document.documentElement.style.setProperty('--theme-font-family', 'Cairo');
  }

  private clearBrandingCache(): void {
    localStorage.removeItem('LOGO_IMAGE_PATH');
    localStorage.removeItem('CUSTOM_LOGO_PATH');
    localStorage.removeItem('THEME_LOGO_DATA');
    localStorage.removeItem('THEME_FONT');
    document.documentElement.style.setProperty('--theme-font-family', 'Cairo');
  }

  public checkAccountValidity(error) {
    const isForbidden = error?.status === 403;
    const isDeactivated = error?.error?.code === 'ACCOUNT_DEACTIVATED';
    const isDisabledException = error?.error?.exception?.includes('DisabledException');
    const hasDisabledDetails = error?.error?.details?.some((detail: string) =>
      detail?.includes('User is disabled')
    );
    const hasDisabledMessage =
      error?.error?.message?.toLowerCase()?.includes('pending activation') ||
      error?.error?.message?.toLowerCase()?.includes('user is disabled');

    const shouldOpenMotionDialog =
      isForbidden && (isDeactivated || isDisabledException || hasDisabledDetails || hasDisabledMessage);

    if (!shouldOpenMotionDialog) {
      return;
    }

    const isMotionDialogOpen = this.dialog.openDialogs.some(
      dialogRef => dialogRef.componentInstance instanceof MotionComponent
    );
    if (isMotionDialogOpen) {
      return;
    }

    // Extract deactivation reason from the response details
    const deactivationReason = isDeactivated
      ? (error?.error?.details?.[0] || '')
      : '';

    this.dialog.open(MotionComponent, {
      data: { isVisible: true, deactivationReason }
    });
  }

  public forceLogoutWithReason(reason: string, code: string) {
    const lang = localStorage.getItem('LANG');
    const themeData = localStorage.getItem('THEME_LOGO_DATA');
    const theme = localStorage.getItem('theme');
    const themeFont = localStorage.getItem('THEME_FONT');
    const favoriteStorage = this.getFavoriteStorageSnapshot();
    localStorage.clear();
    sessionStorage.clear();
    this.restoreFavoriteStorage(favoriteStorage);
    localStorage.setItem('LANG', lang);
    if (themeData) {
      const parsedThemeData = JSON.parse(themeData);
      localStorage.setItem('THEME_LOGO_DATA', themeData);
      localStorage.setItem('LOGO_IMAGE_PATH', parsedThemeData.logoUrl);
      localStorage.setItem('CUSTOM_LOGO_PATH', parsedThemeData.imagePath);
      localStorage.setItem('theme', theme);
    }
    if (themeFont) {
      localStorage.setItem('THEME_FONT', themeFont);
    }

    this._router.navigate(['/index/login']).then(() => {
      this.dialog.open(MotionComponent, {
        data: { isVisible: true, deactivationReason: reason }
      });
    });
  }

  register(requestBody) {
    return this._base.post(requestBody, `${this.logInEndPoint}`).pipe(
      tap(
        (res) => {
          console.log(res)
        },
        (error) => {
          console.log(error);
        },
        () => {
          console.log()
        }
      )
    );
  }


  registerCustomer(requestBody) {
    return this._base.post(requestBody, `${this.registerCustomerEndPoint}`).pipe(
      tap(
        (res) => {
          console.log(res);
        },
        (error) => {
          console.log(error);
        },
        () => {
          console.log()
        }
      )
    );
  }

  /**
   * Verify email
   * @param code
   * @returns
   */
  verifyEmail(code: string) {
    return this._base.post({}, `api/v1/auth/verifiy-email?code=${code}`);
  }

  deleteAccount(requestBody) {
    return this._base.post(requestBody, `api/v1/appuser/delete/request`);
  }

  getCountry() {
    return this._base.get(this.countryEndPoint);
  }

  getUserByPhoneNumber(phoneNumber, userTypeCode) {
    return this._base
      .get(`${this.checkPhoneNumber}=${phoneNumber}&userTypeCode=${userTypeCode}`);
  }

  //get bank list
  getBankList() {
    return this._base.get(this.bankList);
  }

  // deleteItemAttach(itemAttachId: number): Observable<Item> {
  //   return this._base.deleteById(`api/v1/item-attach?id=${itemAttachId}`);
  // }
  //
  //
  // uploadItemAttachments(attachments: ItemAttach[]): Observable<any> {
  //   return this._base.post(attachments, 'api/v1/item-attach/all');
  // }

  updateNotificationToken(req) {
    return this._base.put(req, 'api/v1/user-notification/update-token');
  }

  disableGuide() {
    return this._base.put({}, 'api/v1/appuser/showTutorialGuide?showTutorial=false');
  }

  requestConfigData() {
    if (!navigator.onLine) {
      this.loadCachedConfig();
      return;
    }

    this.configObservable()
      .subscribe((res) => {
        if (res?.status !== 304 && res?.body?.success) {
          const incoming = res.body.data || {};
          const existingConfig = JSON.parse(localStorage.getItem('CONFIG') || '{}');

          // Merge all incoming config data with existing CONFIG
          // This ensures all list of values from the API are available to components
          const mergedConfig = {
            ...existingConfig,
            ...incoming
          };


          // Keep BehaviorSubject in sync
          this.config.next(mergedConfig);
          localStorage.setItem('CONFIG', JSON.stringify(mergedConfig));
        }
      });
  }

  private loadCachedConfig(): void {
    try {
      const cachedConfig = JSON.parse(localStorage.getItem('CONFIG') || 'null');
      if (cachedConfig) {
        this.config.next(cachedConfig);
      }
    } catch (error) {
      console.warn('Failed to load cached config', error);
    }
  }

  configObservable() {
    return this._base
      .get(`${this.portalConfigEndPoint}`, null, true);
  }

  forget(email) {
    return this._base.get(`${this.forgetEndPoint}?email=${email}`);
  }

  checkResetLink(code) {
    return this._base.get(`${this.checkResetEndPoint}?code=${code}`);
  }

  changePassword(query) {
    // ?code=${query.code}&newPassword=${query.password}
    return this._base.post(
      query,
      `${this.changePasswordEndPoint}`
    );
  }

  logout() {
    this.logoutMethod().subscribe((res) => {
      console.log(res)
      const lang = localStorage.getItem('LANG');
      const themeData = localStorage.getItem('THEME_LOGO_DATA');
      const theme = localStorage.getItem('theme');
      const themeFont = localStorage.getItem('THEME_FONT');
      const customLogoPath = localStorage.getItem('CUSTOM_LOGO_PATH');
      const favoriteStorage = this.getFavoriteStorageSnapshot();
      localStorage.clear();
      sessionStorage.clear();
      this.restoreFavoriteStorage(favoriteStorage);
      localStorage.setItem('LANG', lang);
      // Preserve current customer's branding for login page display
      if (themeData) {
        localStorage.setItem('THEME_LOGO_DATA', themeData);
        localStorage.setItem('CUSTOM_LOGO_PATH', customLogoPath || '');
        localStorage.setItem('theme', theme);
      }
      if (themeFont) {
        localStorage.setItem('THEME_FONT', themeFont);
      }
      this._router.navigate(['/index/login']);
    });
  }

  refreshToken(): Observable<any> {
    if (!navigator.onLine) {
      return of({ success: true, offline: true });
    }

    const refreshToken = JSON.parse(localStorage.getItem('REFRESH_TOKEN'));
    const currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
    const refreshReq = { refreshToken: refreshToken, attendToken: false };
    return this._base.post(refreshReq, this.refreshTokenEndPoint).pipe(
      tap((res) => {
        if (res?.data?.jwt?.length) {
          currentUser.isFreeTrial = res?.data?.isFreeTrial;
          currentUser.remainingDay = res?.data?.remainingDay;
          localStorage.setItem('CURRENT_USER', JSON.stringify(currentUser));
          localStorage.setItem('ACCESS_TOKEN', JSON.stringify(res.data.jwt));
          // this.startRefreshTokenTimer();
        } else {
          this.logout();
        }
      }),
      catchError(error => {
        if (!navigator.onLine || error?.status === 0 || error?.status === 504) {
          console.warn('refreshToken skipped because API is unreachable; continuing with cached session.', error);
          return of({ success: true, offline: true });
        }

        console.log('refreshToken >> on error ', error);
        this.logout();
        return of(null);
      })
    );
  }

  logoutMethod(): Observable<any> {
    const refreshToken = JSON.parse(localStorage.getItem('REFRESH_TOKEN'));
    const refreshReq = { refreshToken };
    return this._base.post(refreshReq, `${this.logoutEndPoint}`);
  }

  checkScreenPriv(route: string): boolean {
    // Check if user is authenticated first
    const token = localStorage.getItem('ACCESS_TOKEN');
    if (!token) {
      return false;
    }

    // Screen-level gating for /pages routes is intentionally deferred to the
    // card-permission system (CardRoutePermissionGuard + CardPermissionService)
    // and the backend-filtered menu. Hub cards navigate to sibling routes that
    // are NOT separate USER_SCREENS entries, so a route-prefix check here would
    // wrongly block them and produce blank pages. Allow all /pages routes and
    // let the card guards + menu handle visibility/authorization.
    const normalizedRoute = route.split(/[?#]/, 1)[0].replace(/^\/+|\/+$/g, '').toLowerCase();
    if (normalizedRoute === 'pages' || normalizedRoute.startsWith('pages/')) {
      return true;
    }

    return true;
  }

  /**
   *get countries
   */
  getCountries() {
    return this.getListData('api/v1/country');
  }


  /**
   *
   * @param endPointUrl
   */
  getListData(endPointUrl: string): Observable<any> {
    return this._base.get(endPointUrl).pipe(
      tap((res) => {
        console.log(
          `Service : ${endPointUrl.split('/').pop()} loaded successfully`,
          res
        );
      }),
      catchError(
        this.handleError<any>(
          `Get ${endPointUrl.split('/').pop()} Failded .. `
        )
      )
    );
  }

  /**
   *error handeler
   * @param operation
   * @param result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    console.log(operation)
    return (error): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getreferralSetting(branchId, accountManagerPhoneNumber, customerPhoneNumber) {
    return this._base
      .get(`${this.referralSettingEndPoint}?branchId=${branchId}&accountManagerPhoneNumber=${accountManagerPhoneNumber}&customerPhoneNumber=${customerPhoneNumber}`);
  }

  // getCustomerBranches() {
  //   return this._base.get(`${this.CustomerBranchesEndPoint}`);
  // }

  getCustomerBranches() {
    return this._base.get(`api/v1/customer-branch/config`);
  }

  getUserTheme(cId: number) {
    if (!cId) {
      return of({ success: false, data: null });
    }
    return this._base.get(`${this.customerThemeEndPoint}/customer/${cId}`);
  }

  updateLogoImage() {
    const theme = JSON.parse(localStorage.getItem('theme') || '{}');
    if (theme.logoPath) {
      localStorage.setItem('LOGO_IMAGE_PATH', theme.logoPath);
      localStorage.setItem('CUSTOM_LOGO_PATH', theme.logoPath.replace(environment.baseImageUrl, ''));
      return;
    }

    const themeId = theme.id;
    if (!themeId) return;
    const pathId = this.constant.IMAGE_SETUP_CUSTOMER_BRANCH;

    this._base.get(`api/v1/upload/cloud/file?id=${themeId}&pathId=${pathId}`).subscribe({
      next: (response) => {
        if (response.success && response.data.imagePath) {
          const logoPath = environment.baseImageUrl + response.data.imagePath;
          // Save logo path with theme data
          theme.logoPath = logoPath;
          localStorage.setItem('theme', JSON.stringify(theme));
          localStorage.setItem('LOGO_IMAGE_PATH', logoPath);
          localStorage.setItem('CUSTOM_LOGO_PATH', response.data.imagePath);
        }
      },
      error: () => {
        localStorage.setItem('LOGO_IMAGE_PATH', './assets/images/newLogo.png');
      }
    });
  }
}

